<template>
<div class="chapter">
<div class="inner_page">
<div class="group">
<p class="C593"><span class="size_145"><span class="color_0B0E11"><strong><span id="id_5">Line</span> and Shape</strong></span></span></p>
<p class="C580">Lines connect elements; they lead the eye and create movement, patterns, and relationships. Use line in repetition to lead the eye where you want it to go, to tell a story, or to create an emotional response. The angles of diagonal lines create movement and depth—they are very active and dynamic. Soft, gentle curves are comfortable and relaxing, even sensual; horizontal lines are restful, while vertical lines are lofty and grand. In combination, vertical and horizontal lines are solid and reliable.</p>
</div>
<div class="group">
<p class="C580"><em>Intersections</em> uses a combination of diagonal lines and circular motifs to create a dynamic and active story.</p>
<p class="C572"><img alt="" src="img/15_3.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12___Line_a.vue?73df204b